import { TranslateService } from '@ngx-translate/core';
import { TranslatedString } from 'lemunzo-api';
import { LanguageCode } from '../models/language-code';

/**
 * Resolves a `TranslatedString` for the current ngx-translate locale, then the configured fallback.
 *
 * @param model - `TranslatedString` from the API, or absent.
 * @param translateService - ngx-translate service used for locale resolution.
 * @param options.missingText - Returned when neither current nor fallback locale has a non-empty value.
 * @returns The translation, `missingText`, or `null` when the model has no translations.
 */
export function resolveTranslatedString(
    model: TranslatedString | null | undefined,
    translateService: TranslateService,
    options?: { missingText?: string | null }
): string | null {
    if (model?.translations == null) {
        return null;
    }

    const translations = model.translations;
    const currentLangCode = translateService.getCurrentLang();

    const translation =
        translations[currentLangCode]?.length > 0
            ? translations[currentLangCode]
            : translations[translateService.getFallbackLang() as LanguageCode];

    if (translation?.length > 0) {
        return translation;
    }

    return options?.missingText ?? null;
}
